/* Timber custom: variant dropdown listbox (July 2026). Native <select>
   option lists are OS-rendered and unstylable, so each variant dropdown is
   enhanced into the details-listbox pattern the collection sidebar's sort
   control uses: a pill summary and a white card panel with tan-wash rows
   and a dark-tan check. The native select stays in the DOM (visually
   hidden, tabindex -1) as the source of truth — options click through to
   select.value + a bubbled change event, so Dawn's variant-selects
   machinery sees exactly what it always saw; the UI re-syncs from the
   select's own change event. Without JS the pill-skinned native select
   still works. */
(function () {
  function enhance(wrap) {
    if (wrap.dataset.tselect) return;
    var selectDiv = wrap.querySelector('.select');
    var select = selectDiv && selectDiv.querySelector('select');
    if (!select) return;
    wrap.dataset.tselect = 'true';

    var CHECK =
      '<svg class="tselect__check" viewBox="0 0 11 7" aria-hidden="true" focusable="false"><path d="M1.5 3.5L4.2 6 9.5 1" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var details = document.createElement('details');
    details.className = 'tselect';
    var summary = document.createElement('summary');
    summary.className = 'tselect__summary';
    summary.setAttribute('aria-haspopup', 'listbox');
    /* The pill is sized by the WIDEST option, not the current one — an
       invisible zero-height stack of every option label shares the label's
       grid cell, so the trigger and the panel (min-width: 100%) render at
       the same width and nothing shifts when the choice changes. */
    var labelwrap = document.createElement('span');
    labelwrap.className = 'tselect__labelwrap';
    var label = document.createElement('span');
    label.className = 'tselect__label';
    var sizer = document.createElement('span');
    sizer.className = 'tselect__sizer';
    sizer.setAttribute('aria-hidden', 'true');
    Array.prototype.forEach.call(select.options, function (opt) {
      var s = document.createElement('span');
      s.textContent = opt.text;
      sizer.appendChild(s);
    });
    labelwrap.appendChild(label);
    labelwrap.appendChild(sizer);
    summary.appendChild(labelwrap);
    summary.insertAdjacentHTML(
      'beforeend',
      '<svg class="tselect__caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );

    var panel = document.createElement('div');
    panel.className = 'tselect__panel';
    panel.setAttribute('role', 'listbox');

    Array.prototype.forEach.call(select.options, function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tselect__option';
      btn.setAttribute('role', 'option');
      btn.dataset.value = opt.value;
      btn.innerHTML = '<span>' + opt.text + '</span>' + CHECK;
      btn.addEventListener('click', function () {
        if (select.value !== opt.value) {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        details.removeAttribute('open');
        summary.focus();
      });
      panel.appendChild(btn);
    });

    function sync() {
      var current = select.options[select.selectedIndex];
      label.textContent = current ? current.text : '';
      panel.querySelectorAll('.tselect__option').forEach(function (btn) {
        var on = current && btn.dataset.value === current.value;
        btn.classList.toggle('is-selected', !!on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    sync();
    select.addEventListener('change', sync);

    details.appendChild(summary);
    details.appendChild(panel);
    selectDiv.after(details);
    selectDiv.classList.add('tselect-native');
    select.tabIndex = -1;

    details.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && details.hasAttribute('open')) {
        details.removeAttribute('open');
        summary.focus();
      }
    });
  }

  function init() {
    document.querySelectorAll('.product__info-wrapper variant-selects .product-form__input--dropdown').forEach(enhance);
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('details.tselect[open]').forEach(function (open) {
      if (!open.contains(event.target)) open.removeAttribute('open');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
